import { Injectable } from '@angular/core';
import { AwsProvider } from '../../providers/aws/aws';

/**
 * For manipulating and retrieving account data
 */
@Injectable()
export class AccountProvider {

opportunities: Array<object>;

  verticalInformation: object; // all preferences and labels for subsections in chosen vertical
  cart: object; // current cart of user, containing all required information to restore

  constructor(public aws: AwsProvider) {
    this.verticalInformation = {};
  }

  /**
   * Create a new user account
   * @param userData user attributes to create an account with
   * This sends data to our SherloQ Admin API which forwards it to LambdaAdminCreateUser.
   */
  createAccount(userData: object): Promise<object> {
    console.log('Registering new account with email: ' + userData['email']);
    return this.aws.invokeLambda('LambdaAdminCreateUser', userData)
      .then((response) => {
        console.log('Account created.');
        return { success: true };
      }).catch((error) => {
        console.log('Registration error');
        if (error['message']) {
          return { success: false, message: error['message'] };
        } else {
          return { success: false, message: JSON.stringify(error) };
        }
      });
  }

  /**
   * Edit a User account
   * @param userData user attributes to create an account with
   * This sends data to our SherloQ Admin API which forwards it to LambdaAdminEditUser.
   */
  editAccount(userData: object): Promise<object> {
    console.log('Editing User account with email: ' + userData['email']);
    return this.aws.invokeLambda('SherloqAdminFEEditUser', { 'userData': userData })
      .then((response) => {
        console.log('Account edited.', response);
        return { success: true };
      }).catch((error) => {
        console.log('Error editing User account');
        if (error['message']) {
          return { success: false, message: error['message'] };
        } else {
          return { success: false, message: JSON.stringify(error) };
        }
      });
  }
  /**
   * Edit a Agency account
   * @param userData user attributes to create an account with
   * This sends data to our SherloQ Admin API which forwards it to LambdaAdminEditUser.
   */
   editAgency(agencyData: object): Promise<object> {
    console.log('Editing Agency account with email: ' + agencyData['companyName']);
    return this.aws.invokeLambda('SherloqAdminFEEditUserAgencyFields', agencyData)
      .then((response) => {
        console.log('Account edited.');
        return { success: true };
      }).catch((error) => {
        console.log('Error editing User account');
        if (error['message']) {
          return { success: false, message: error['message'] };
        } else {
          return { success: false, message: JSON.stringify(error) };
        }
      });
  }
  /**
   * Edit call & chat endpoints in a User account
   * @param userData is a full User record, containing objectId
   * This sends data to our SherloQ Admin API which forwards it to LambdaAdminEditUser.
   */
  editEndpoints(userData: object): Promise<object> {
    console.log('Editing endpoints in User account with objectId: ' + userData['objectId']);
    return this.aws.invokeLambda('LambdaAdminEditEndpoints', userData )
      .then((response) => {
        console.log('Endpoints edited.');
        return { success: true };
      }).catch((error) => {
        console.log('Error editing endpoints');
        if (error['message']) {
          return { success: false, message: error['message'] };
        } else {
          return { success: false, message: JSON.stringify(error) };
        }
      });
  }

  /**
   * Get the main verticals a user can choose from
   */
  getVerticals() {
    return this.aws.invokeLambda('LambdaAdminGetVerticals', { 'drilldown': true })
      .then((result) => {
        if (result['success']) {
          return result['response'];
        } else {
          return null;
        }
      });
  }

  /**
   * Get the agents a user can choose from
   */
  getAgents() {
    return this.aws.invokeLambda('SherloqAdminFEGetAgentsFromUserTable')
      .then((result) => {
        if (result['success']) {
          return result['response']['Items'].map((agent) => {
            return {'companyName' : agent['companyName'], 'objectId' : agent['objectId']}
          });
        } else {
          return null;
        }
      });
  }

}



// WEBPACK FOOTER //
// ./src/providers/account/account.ts